<template>
	<div class="layout-toggle">
		<checkbox-toggle
			:label="'Full Width'"
			@input="onLayoutChange"
			:value="isFullWidth"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CheckboxToggle from '@/components/CheckboxToggle.vue';

export default {
	name: 'LayoutToggle',
	components: {
		CheckboxToggle,
	},
	methods: {
		...mapActions({
			setFullWidth: 'setFullWidth',
		}),
		setLayout() {
			const layoutFull = localStorage.getItem('layout-full');
			const isFullWidth = layoutFull === 'true';
			this.setFullWidth(isFullWidth);
		},
		onLayoutChange(value) {
			const isFullWidth = value;
			localStorage.setItem('layout-full', isFullWidth);
			this.setFullWidth(isFullWidth);
		},
	},
	computed: {
		...mapGetters({
			isFullWidth: 'isFullWidth',
		}),
	},
	created() {
		this.setLayout();
	},
};
</script>
